// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import type { HttpClientInstance } from '@toggl/sync/http';
import type {
  Interview,
  InterviewCreateInterviewPayload,
  InterviewEvaluation,
  InterviewEvaluationPayload,
  InterviewGenerateParams,
  InterviewSection,
} from '../types';

export async function getEvaluations(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(
      `workspaces/${workspaceId}/openings/${openingId}/candidates/${candidateId}/interviews/${interviewId}/evaluations`,
      { signal }
    )
    .json<InterviewEvaluation[]>();
  return response;
}

export async function postInterviewEvaluation(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number,
  data: InterviewEvaluationPayload,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(
      `workspaces/${workspaceId}/openings/${openingId}/candidates/${candidateId}/interviews/${interviewId}/evaluations`,
      { signal, json: data }
    )
    .json<InterviewEvaluation>();
  return response;
}

export async function putEvaluations(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number,
  evaluationId: number,
  data: InterviewEvaluationPayload,
  signal?: AbortSignal
) {
  const response = await httpClient
    .put(
      `workspaces/${workspaceId}/openings/${openingId}/candidates/${candidateId}/interviews/${interviewId}/evaluations/${evaluationId}`,
      { signal, json: data }
    )
    .json<InterviewEvaluation>();
  return response;
}

export async function deleteEvaluation(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  candidateId: number,
  interviewId: number,
  evaluationId: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .delete(
      `workspaces/${workspaceId}/openings/${openingId}/candidates/${candidateId}/interviews/${interviewId}/evaluations/${evaluationId}`,
      { signal }
    )
    .json<unknown>();
  return response;
}

export async function getInterview(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  stageId: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .get(
      `workspaces/${workspaceId}/openings/${openingId}/stages/${stageId}/interview`,
      { signal }
    )
    .json<Interview>();
  return response;
}

export async function updateInterview(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  stageId: number,
  data: Interview,
  signal?: AbortSignal
) {
  const response = await httpClient
    .put(
      `workspaces/${workspaceId}/openings/${openingId}/stages/${stageId}/interview`,
      { signal, json: data }
    )
    .json<Interview>();
  return response;
}

export async function createInterview(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  stageId: number,
  data: InterviewCreateInterviewPayload,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(
      `workspaces/${workspaceId}/openings/${openingId}/stages/${stageId}/interview`,
      { signal, json: data }
    )
    .json<Interview>();
  return response;
}

export async function deleteInterview(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  stageId: number,
  signal?: AbortSignal
) {
  const response = await httpClient
    .delete(
      `workspaces/${workspaceId}/openings/${openingId}/stages/${stageId}/interview`,
      { signal }
    )
    .json<unknown>();
  return response;
}

export async function generateInterviewAi(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  stageId: number,
  data: InterviewGenerateParams,
  signal?: AbortSignal
) {
  const response = await httpClient
    .post(
      `workspaces/${workspaceId}/openings/${openingId}/stages/${stageId}/interview/generate`,
      { signal, json: data }
    )
    .json<InterviewSection[]>();
  return response;
}
